// Formats built by core (POST /services/route-export); ecdis = text download.
export const ROUTE_EXPORT_FORMATS = [
  { value: "geojson", label: "GeoJSON", ext: "geojson", mime: "application/geo+json" },
  { value: "voyageFile", label: "MP4 Voyage File", ext: "json", mime: "application/json" },
  { value: "rtz", label: "RTZ (eGlobe)", ext: "rtz", mime: "application/xml", ecdis: true },
  { value: "rtzIec10", label: "RTZ 1.0 (IEC 61174)", ext: "rtz", mime: "application/xml", ecdis: true },
  { value: "rtzIec11", label: "RTZ 1.1 (IEC 61174)", ext: "rtz", mime: "application/xml", ecdis: true },
  { value: "furunoWpCsv", label: "FURUNO WP List (.csv)", ext: "csv", mime: "text/csv", ecdis: true },
  { value: "furunoWpTxt", label: "FURUNO WP List (.txt)", ext: "txt", mime: "text/plain", ecdis: true },
  { value: "jrc", label: "JRC (.csv)", ext: "csv", mime: "text/csv", ecdis: true },
]

export const DEFAULT_EXPORT_FORMAT = "voyageFile"

const BY_VALUE = new Map(ROUTE_EXPORT_FORMATS.map((f) => [f.value, f]))

export const routeExportFormat = (value) => BY_VALUE.get(value) ?? null

// Vessel formats are maintained in the shipping DB, in order; none set = all formats.
export function exportFormatsForVessel(vessel) {
  const own = [...new Set(vessel?.routeExportFormats ?? [])].map((value) => BY_VALUE.get(value)).filter(Boolean)
  return own.length ? own : ROUTE_EXPORT_FORMATS
}

export function initialExportFormat(vessel) {
  const options = exportFormatsForVessel(vessel)
  return options === ROUTE_EXPORT_FORMATS ? DEFAULT_EXPORT_FORMAT : options[0].value
}

export const IMPORT_FILE_ACCEPT = ".json,.rtz"

export const routeFormatLabel = (value) => BY_VALUE.get(value)?.label ?? value ?? ""

// Like the export list: maintained in the shipping DB, none set = every format.
export function vesselAcceptsImportFormat(vessel, format) {
  const own = vessel?.routeImportFormats ?? []
  return own.length === 0 || own.includes(format)
}
